<template>
  <StandardLayout>
    <div slot="main" class="mx-12 my-6">
      <Hero />
      <Explainer />
      <FeaturedCreations />
      <FeaturedCreators />
      <FeaturedGuilds />
    </div>
  </StandardLayout>
</template>

<script>
import StandardLayout from '@/layouts/Standard.vue'
import Hero from '@/components/landing/Hero.vue'
import Explainer from '@/components/landing/Explainer.vue'
import FeaturedCreations from '@/components/landing/FeaturedCreations.vue'
import FeaturedCreators from '@/components/landing/FeaturedCreators.vue'
import FeaturedGuilds from '@/components/landing/FeaturedGuilds.vue'

export default {

  name: 'LandingView',
  
  components: {
    StandardLayout,
    Hero,
    Explainer,
    FeaturedCreations,
    FeaturedCreators,
    FeaturedGuilds,
  },
  
}
</script>

<style lang="scss" scoped>
</style>